module.exports = __webpack_public_path__ + "static/media/pic3.a60300d4.jpg";